module.exports = __webpack_public_path__ + "img/ws.5e6775d6.png";